/**
 * Flatten method-related fields on cash-in / cash-out requests for client-side search.
 * Includes multilingual JSON labels and nested payment method objects.
 */
export function buildCashRequestMethodSearchText(req) {
  const parts = [];

  const pushDeep = (v, depth = 0) => {
    if (v == null || depth > 12) return;
    if (typeof v === "string") {
      const t = v.trim();
      if (!t) return;
      parts.push(t);
      if (
        (t.startsWith("{") && t.includes("}")) ||
        (t.startsWith("[") && t.includes("]"))
      ) {
        try {
          pushDeep(JSON.parse(t), depth + 1);
        } catch (_) {
          /* not JSON */
        }
      }
      return;
    }
    if (typeof v === "number" || typeof v === "boolean") {
      parts.push(String(v));
      return;
    }
    if (Array.isArray(v)) {
      v.forEach((x) => pushDeep(x, depth + 1));
      return;
    }
    if (typeof v === "object") {
      Object.values(v).forEach((x) => pushDeep(x, depth + 1));
    }
  };

  const raw = req?.raw || {};
  pushDeep(req?.methodLabel);
  pushDeep(raw.METHOD_LABEL);
  pushDeep(raw.METHOD_NAME);
  pushDeep(raw.METHOD);
  pushDeep(raw.method);
  pushDeep(raw.PAYMENT_METHOD_LABEL);
  pushDeep(raw.PAYMENT_METHOD_NAME);
  pushDeep(raw.METHOD_SLUG);
  pushDeep(raw.method_slug);
  pushDeep(raw.METHOD_ID);
  pushDeep(raw.PAYMENT_METHOD_ID);
  pushDeep(raw.CASHIN_METHOD_ID);
  pushDeep(raw.CASHOUT_METHOD_ID);
  pushDeep(raw.METHOD_TYPE);
  pushDeep(raw.TYPE);
  pushDeep(raw.payment_methods);
  pushDeep(raw.PAYMENT_METHOD);
  pushDeep(raw.PaymentMethod);
  pushDeep(raw.cashin_method);
  pushDeep(raw.cashout_method);

  return parts.join(" ").toLowerCase();
}

/**
 * @param {string} q trimmed lowercase query
 * @param {string} haystack lowercase joined searchable text
 */
export function queryMatchesHaystack(q, haystack) {
  if (!q) return true;
  const tokens = q.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  return tokens.every((tok) => haystack.includes(tok));
}
